var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvisible(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0549 18.7462L19 22.2804L20.5364 21L5.53644 3L4 4.28037L6.20275 6.92367C4.32208 8.19389 2.84422 10.0168 2 12.1591C3.65138 16.3495 7.72726 19.3182 12.5 19.3182C13.7428 19.3182 14.9378 19.1173 16.0549 18.7462ZM14.2625 16.5954L12.9257 14.9912C12.7868 15.012 12.6447 15.0227 12.5 15.0227C10.9203 15.0227 9.63641 13.7389 9.63641 12.1591C9.63641 11.8339 9.69083 11.5212 9.79104 11.2296L8.4548 9.62613C7.99387 10.3603 7.72726 11.2287 7.72726 12.159C7.72726 14.7936 9.86546 16.9318 12.5 16.9318C13.1224 16.9318 13.7171 16.8124 14.2625 16.5954ZM23 12.1591C22.1964 14.1983 20.8198 15.9481 19.0676 17.2074L16.7305 14.3695C17.0768 13.7085 17.2727 12.9566 17.2727 12.1591C17.2727 9.52454 15.1345 7.38634 12.5 7.38634C12.0281 7.38634 11.5721 7.45496 11.1414 7.58274L9.37595 5.43898C10.3679 5.15315 11.416 5 12.5 5C17.2775 5 21.3486 7.9686 23 12.1591ZM15.3637 12.1591C15.3637 12.329 15.3488 12.4954 15.3204 12.6572L12.5523 9.29594C14.108 9.32386 15.3637 10.5968 15.3637 12.1591Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvisible);
export default __webpack_public_path__ + "static/media/Invisible.fe89bc799b0dee1fae07ca683f068a6e.svg";
export { ForwardRef as ReactComponent };